import React from 'react';
import { Container } from "./styles";

const Input = (props) => {
    return (
        <Container {...props}/>
    )
}

export default Input;
